<template>
  <div>
    <div class="md-layout md-alignment-left">
          <md-checkbox
            class="md-layout-item md-small-size-100 md-size-20"
            v-model="asset.has_liability"
            :disabled="asset_type_properties.has_liability !== null"
            >Liability</md-checkbox>
    </div>
    <div class="md-layout" v-if="asset.has_liability">
      <!-- Finance Provider -->
      <validated-autocomplete-input
        class="md-layout-item md-small-size-100 md-size-30"
        label="Finance Provider"
        v-model="asset.finance.provider"
        :prefixLabel="prefixLabel"
        :options="options.asset_finance_provider"
        autocompleteDisabled
      >
      </validated-autocomplete-input>

      <!-- Outstanding Amount -->
      <validated-input
        type="CURRENCY"
        class="md-layout-item md-small-size-100 md-size-30"
        label="Outstanding"
        :prefixLabel="prefixLabel"
        prefix="$"
        v-model="asset.finance.outstanding_amount"
      />

      <!-- Original Amount -->
      <validated-input
        type="CURRENCY"
        class="md-layout-item md-small-size-100 md-size-30"
        :label="isCreditCard ? 'Limit' : 'Original'"
        :prefixLabel="prefixLabel"
        prefix="$"
        v-model="asset.finance.original_amount"
      />

      <!-- Duration Years -->
      <validated-input
        v-if="!isCreditCard"
        type="DURATION_YEARS"
        class="md-layout-item md-small-size-100 md-size-15"
        label="Years"
        :prefixLabel="prefixLabel"
        v-model="asset.finance.duration.years"
      />

      <!-- Duration Months -->
      <validated-input
        v-if="!isCreditCard"
        type="DURATION_MONTHS"
        class="md-layout-item md-small-size-100 md-size-15"
        label="Months"
        :prefixLabel="prefixLabel"
        v-model="asset.finance.duration.months"
      />

      <!-- Expense Amount-->
      <validated-input
        type="CURRENCY"
        class="md-layout-item md-small-size-100 md-size-40"
        :label="isCreditCard ? 'Repayments (Limit x 4%)' : 'Repayments'"
        :prefixLabel="prefixLabel"
        prefix="$"
        v-model="asset.expense.amount"
        :suffix="toMonthlyAmount(asset.expense.amount, asset.expense.frequency, true) + '/m'"
        :disabled="isCreditCard"
        :readonly="isCreditCard"
      />

      <!-- Expense Frequency -->
      <validated-autocomplete-input
        class="md-layout-item md-small-size-100 md-size-30"
        label="Frequency"
        v-model="asset.expense.frequency"
        :prefixLabel="prefixLabel"
        :options="options.payment_frequency_options"
        :disabled="isCreditCard"
        :readonly="isCreditCard"
        force
      />

    </div>

  </div>

</template>

<script>
import { mapGetters } from "vuex";
import filters from "@/components/utils/filters";
import utils from "@/components/utils/utils";
import ValidatedInputs from "@/components/ValidatedInput";
import ListItemCard from "@/components/Cards/ListItemCard.vue";
import SearchAddress from '@/components/SearchAddress.vue';

export default {
  components: {
    ...ValidatedInputs,
    ListItemCard,
    SearchAddress
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    duration: {
      type: Boolean,
      default: false,
    },
    ownership: {
      type: Boolean,
      default: false,
    },
    prefixLabel: {
      type: String,
      default: "",
    },
  },
  beforeMount(){
    this.matchAssetsHasToType();
  },
  watch: {

    "asset.type"() {
      this.matchAssetsHasToType();
      if (this.isCreditCard) {
        this.asset.expense.amount = (
          this.asset.finance.original_amount * 0.04
        ).toFixed(0);
        this.asset.expense.frequency = "Monthly";
      }
    },
    "asset.finance.original_amount"() {
      if (this.isCreditCard) {
        this.asset.expense.amount = (
          this.asset.finance.original_amount * 0.04
        ).toFixed(0);
        this.asset.expense.frequency = "Monthly";
      }
    },
  },
  computed: {
    // standard list of options from store
    ...mapGetters(["options", "properties"]),
    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    asset: {
      get() {
        return this.value;
      },
      set(asset) {
        this.$emit("input", asset);
      },
    },
    asset_type_properties() {
      let properties =
        this.properties.asset_type_properties &&
        this.properties.asset_type_properties[this.asset.type];
      if (properties) {
        return properties;
      } else {
        return {
          has_liability: false,
        };
      }
    },
    isCreditCard() {
      return this.asset.type == "Credit Card";
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,
    ...utils,
    matchAssetsHasToType() {
      // set has_liability to the types default
      if (this.asset_type_properties.has_liability !== null) {
        this.asset.has_liability = this.asset_type_properties.has_liability;
      }
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  async beforeCreate() {
    const params = {
      types: [
        'asset_finance_provider',
        'asset_type_properties',
        'payment_frequency_options',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/theme.scss";

.divide-right {
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
